import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsDepositButtonControl } from "../ags-deposit-button-control";

export class AgsDepositButtonControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("ags_deposit") != null;
    }

    public build(layer: Layers): AgsDepositButtonControl[] {
        return [new AgsDepositButtonControl(layer.getFlexiButton("ags_deposit"))];
    }
}
